import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
var _Toast;
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { ToastComponent } from "./toast.component.js";
import { ToastOverlayComponent } from "./toast.overlay.component.js";
var _window = /*#__PURE__*/new WeakMap();
var _document = /*#__PURE__*/new WeakMap();
var _components = /*#__PURE__*/new WeakMap();
var _addComponents = /*#__PURE__*/new WeakMap();
var _options = /*#__PURE__*/new WeakMap();
var _register = /*#__PURE__*/new WeakMap();
export var Toast = /*#__PURE__*/function () {
  function Toast() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Toast);
    _classPrivateFieldInitSpec(this, _window, window);
    _classPrivateFieldInitSpec(this, _document, _classPrivateFieldGet(_window, this).document);
    _classPrivateFieldInitSpec(this, _components, []);
    _classPrivateFieldInitSpec(this, _addComponents, function (component) {
      _classPrivateFieldGet(_components, _this).push(component);
    });
    _classPrivateFieldInitSpec(this, _options, {
      duration: 3000,
      position: "center",
      animation: "default",
      overlay: false
    });
    _defineProperty(this, "components", _classPrivateFieldGet(_components, this));
    _classPrivateFieldInitSpec(this, _register, function () {
      if (!_classPrivateFieldGet(_window, _this).customElements.get("yy-toast-component")) {
        _classPrivateFieldGet(_window, _this).customElements.define("yy-toast-component", ToastComponent);
      }
      if (_classPrivateFieldGet(_options, _this).overlay) {
        if (!_classPrivateFieldGet(_window, _this).customElements.get("yy-toast-overlay-component")) {
          _classPrivateFieldGet(_window, _this).customElements.define("yy-toast-overlay-component", ToastOverlayComponent);
        }
      }
    });
    _classPrivateFieldSet(_options, this, Object.assign(_classPrivateFieldGet(_options, this), Toast.options, options));
    _classPrivateFieldGet(_register, this).call(this);
    Toast.instanceAll.push(this);
  }
  return _createClass(Toast, [{
    key: "clear",
    value: function clear() {
      var components = _classPrivateFieldGet(_components, this);
      while (components.length > 0) {
        this.unmount(components[0]);
        components.splice(0, 1);
      }
    }
  }, {
    key: "create",
    value: function create() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        mounted = _ref.mounted,
        unmounted = _ref.unmounted,
        beforeMount = _ref.beforeMount;
      var toastElement = new ToastComponent();
      var animationName = _classPrivateFieldGet(_options, this).animation;
      var positionClassName = "toast-".concat(_classPrivateFieldGet(_options, this).position);
      mounted || (mounted = function mounted() {});
      unmounted || (unmounted = function unmounted() {});
      beforeMount || (beforeMount = function beforeMount() {});
      toastElement.innerHTML = content;
      toastElement.setAttribute("class", positionClassName);
      if (_classPrivateFieldGet(_options, this).overlay) {
        var overlayName = _classPrivateFieldGet(_options, this).overlay;
        var toastOverlayElement = new ToastOverlayComponent();
        if ({}.toString.call(overlayName) !== "[object String]") {
          overlayName = "default";
        }
        toastOverlayElement.setValue("mounted", mounted);
        toastOverlayElement.setValue("unmounted", unmounted);
        toastOverlayElement.setValue("beforeMount", beforeMount);
        toastOverlayElement.setAttribute("class", "toast-overlay-".concat(overlayName));
        animationName && toastOverlayElement.setAttribute("animation", animationName);
        toastOverlayElement.appendChild(toastElement);
        _classPrivateFieldGet(_addComponents, this).call(this, toastOverlayElement);
        return toastOverlayElement;
      } else {
        toastElement.setValue("mounted", mounted);
        toastElement.setValue("unmounted", unmounted);
        toastElement.setValue("beforeMount", beforeMount);
        animationName && toastElement.setAttribute("animation", animationName);
        _classPrivateFieldGet(_addComponents, this).call(this, toastElement);
        return toastElement;
      }
    }
  }, {
    key: "mount",
    value: function mount(toastElement, duration) {
      var _this2 = this;
      if (!toastElement.parent()) {
        var animationName = _classPrivateFieldGet(_options, this).animation;
        toastElement.getValue("beforeMount")();
        if (animationName) {
          toastElement.setAttribute("animation-route", "create");
          toastElement.addEventListener("animationend", function () {
            toastElement.getValue("mounted")();
          }, {
            once: true
          });
          _classPrivateFieldGet(_document, this).body.appendChild(toastElement);
        } else {
          _classPrivateFieldGet(_document, this).body.appendChild(toastElement);
          toastElement.getValue("mounted")();
        }
        _classPrivateFieldGet(_options, this).duration = duration ? duration : _classPrivateFieldGet(_options, this).duration;
        if (_classPrivateFieldGet(_options, this).duration > 0) {
          var timestamp = setTimeout(function () {
            clearTimeout(timestamp);
            _this2.unmount(toastElement);
          }, _classPrivateFieldGet(_options, this).duration);
        }
      }
    }
  }, {
    key: "unmount",
    value: function unmount(toastElement) {
      if (toastElement.parent()) {
        var animationName = _classPrivateFieldGet(_options, this).animation;
        if (animationName) {
          toastElement.setAttribute("animation-route", "remove");
          toastElement.addEventListener("animationend", function () {
            toastElement.parent().removeChild(toastElement);
            toastElement.getValue("unmounted")();
          }, {
            once: true
          });
        } else {
          toastElement.parent().removeChild(toastElement);
          toastElement.getValue("unmounted")();
        }
      }
    }
  }, {
    key: "isMount",
    value: function isMount(toastElement) {
      return !!toastElement.parent();
    }
  }]);
}();
_Toast = Toast;
_defineProperty(Toast, "options", {
  duration: 3000,
  position: "center",
  animation: "default",
  overlay: false
});
_defineProperty(Toast, "clear", function () {
  var instanceAll = _Toast.instanceAll;
  while (instanceAll.length > 0) {
    instanceAll[0].clear();
    instanceAll.splice(0, 1);
  }
});
_defineProperty(Toast, "instanceAll", []);